import { useState } from 'react';
import { isBoolean } from '@witmetrics/utils/boolean';

export function useToggle(initialValue = false) {
  const [value, setValue] = useState<boolean>(initialValue);

  const toggle = (bool?: boolean) => {
    if (isBoolean(bool)) setValue(bool);
    else setValue((val) => !val);
  };

  return [value, toggle] as const;
}
